import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<>()[\]{}]+(?:[^\s<>()[\]{}.,;:!?'"]*[^\s<>()[\]{}.,;:!?'"]))/gi;

interface LinkifyProps {
	children: string;
	linkStyle?: React.CSSProperties;
	linkProps?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}

const createSafeKey = (prefix: string, index: number, content?: string): string => {
	if (!content) return `${prefix}-${index}`;
	const safeContent = encodeURIComponent(content).slice(0, 50);
	return `${prefix}-${index}-${safeContent}`;
};

export const Linkify: React.FC<LinkifyProps> = ({
	children,
	linkStyle,
	linkProps = { target: '_blank', rel: 'noopener noreferrer' },
}) => {
	const parts = children.split(URL_REGEX);

	return (
		<>
			{parts.map((part, index) => {
				// Split with capture group: even = text, odd = URLs
				const isUrl = index % 2 === 1;

				if (isUrl && part) {
					return (
						<a
							key={createSafeKey('link', index, part)}
							href={part}
							{...linkProps}
							{...(linkStyle && { style: linkStyle })}
						>
							{part}
						</a>
					);
				}

				return part ? <React.Fragment key={createSafeKey('text', index)}>{part}</React.Fragment> : null;
			})}
		</>
	);
};
